// import React, { lazy, Suspense, useEffect, useState } from "react";
// import { useAddressContext } from "../context/AddressContext";
// import { MdArrowBackIos } from "../utils/Icons";
// import Cookies from "js-cookie";
// import { useNavigate } from "react-router-dom";

// // Imports
// import DashboardWrapper from "../components/DashboardWrapper";
// import CustomInput from "../components/CustomComponents/CustomInput";
// import CustomSelect from "../components/CustomComponents/CustomSelect";
// import axios from "axios";
// import { baseUrl } from "../utils/OtherUtils";
// const AddressCard = lazy(() => import("../components/AddressCard"));

// const MyAddress = () => {
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedCity, setSelectedCity] = useState("");

//   const handleStateChange = (e) => {
//     setSelectedState(e.target.value);
//     setSelectedCity("");
//   }


//   const {
//     addressData,
//     addressSave,
//     addAddress,
//     setAddAddress,
//     isAddAddress,
//     setIsAddAddress,
//     getAddresses,
//   } = useAddressContext();
//   const navigate = useNavigate();

//   const handleAddAddress = () => {
//     setIsAddAddress((prev) => !prev);
//   };

//   const handleAddressChange = (name, value) => {
//     setAddAddress((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleRestOfAddress = (e) => {
//     const { name, value } = e.target;
//     setAddAddress((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   }


//   const handleAddressTypeSelect = (type) => {
//     setAddAddress((prevState) => ({
//       ...prevState,
//       type,
//     }));
//   };

//   useEffect(() => {
//     const token = Cookies.get("token");
//     const userId = Cookies.get("userId");

//     if (token && userId) {
//       getAddresses();
//     }
//   }, [getAddresses]);


//   useEffect(() => {
//     if (!addAddress.pincode) return;

//     const fetchPincodeData = async () => {
//       try {
//         const response = await axios.get(`${baseUrl}/api/pincode/${addAddress.pincode}`);
//         console.log('Pincode data:', response.data);
//         handleAddressChange('state', response.data?.PostOffice[0]?.State || '');
//         handleAddressChange('city', response.data?.PostOffice[0]?.District || '');


//       } catch (error) {
//         console.error('Error fetching pincode data:', error);
//       }
//     };

//     fetchPincodeData();
//   }, [addAddress.pincode]);

//   const stateCityData = {
//     "Delhi": ["New Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh"],
//     "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane"],
//     "Karnataka": ["Bengaluru", "Mysuru", "Mangalore", "Hubli", "Belgaum"],
//     "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi", "Noida", "Ghaziabad"],
//     "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer","Indore","Sagar"]
//   };


//   return (
//     <DashboardWrapper>
//       <div className="w-full h-full">
//         <button
//           className="flex items-center font-normal text-[4vw] mb-2 lg:hidden lg:text-[1vw] text-textPrimaryColor"
//           onClick={() => navigate(-1)}
//         >
//           {!isAddAddress && (
//             <>
//               <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
//               <span>Back</span>
//             </>
//           )}
//         </button>
//         {addressData?.length === 0 && !isAddAddress && (
//           <div className="w-full h-full flex flex-col justify-between items-center">
//             <div className="w-full h-[85%] flex justify-center items-center">
//               <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
//                 No Address
//               </p>
//             </div>
//             <button className="btn-primary" onClick={handleAddAddress}>
//               Add Address
//             </button>
//           </div>
//         )}

//         {addressData?.length > 0 && !isAddAddress && (
//           <div className="w-full h-full flex flex-col justify-between items-center space-y-[3%] lg:space-y-0">
//             <div className="w-full h-fit lg:h-[85%] grid grid-cols-1 lg:grid-cols-2 lg:gap-x-[5.5%] gap-y-2 lg:gap-y-[7.5%] overflow-x-hidden overflow-y-scroll scrollbar-hide auto-rows-min">
//               <Suspense
//                 fallback={
//                   <div className="w-full h-full flex justify-center items-center">
//                     <p className="font-normal text-[1vw] text-textSecondaryColor">
//                       Loading addresses...
//                     </p>
//                   </div>
//                 }
//               >
//                 {addressData?.map((address, index) => (
//                   <AddressCard key={index} data={address} />
//                 ))}
//               </Suspense>
//             </div>
//             <button className="btn-primary" onClick={handleAddAddress}>
//               Add Address
//             </button>
//           </div>
//         )}

//         {isAddAddress && (
//           <div className="w-full h-fit space-y-[3%]">
//             <button
//               className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
//               onClick={handleAddAddress}
//             >
//               <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
//               <span>Back</span>
//             </button>
//             <div className="w-full h-fit space-y-[1%]">
//               <span className="font-medium text-[5vw] lg:text-[1.25vw] text-textPrimaryColor">
//                 Address Information
//               </span>
//               <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                 Please provide full details your address for a smooth Home
//                 collection. Ensure accuracy to avoid delays.
//               </p>
//             </div>
//             <div className="w-full h-fit flex justify-between items-center space-x-[5%]">
//               <CustomInput
//                 type="text"
//                 name="house"
//                 placeholder="House No."
//                 value={addAddress.house}
//                 onChange={handleRestOfAddress}
//               />
//               <CustomInput
//                 type="text"
//                 name="area"
//                 placeholder="Area"
//                 value={addAddress.area}
//                 onChange={handleRestOfAddress}
//               />
//             </div>
//             <div className="w-full h-fit flex justify-between items-center">
//               <div className="w-[47.5%] h-fit flex flex-col space-y-[2%]">
//                 <label
//                   htmlFor="pincode"
//                   className="font-normal text-[1vw] text-textSecondaryColor"
//                 ></label>
//                 <input
//                   type="number"
//                   id="pincode"
//                   name="pincode"
//                   placeholder="Pincode"
//                   value={addAddress.pincode}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (value.length <= 6) {
//                       handleRestOfAddress(e);
//                     }
//                   }}
//                   max={999999}
//                   className="input-primary"
//                 />
//               </div>
//             </div>


// Input for state and city selection
//             {/* <div className="w-full h-fit flex justify-between items-center space-x-[5%]">
//               <CustomInput
//                 type="text"
//                 name="state"
//                 placeholder="State"
//                 value={addAddress.state}
//                 onChange={handleRestOfAddress}
//               />
//               <CustomInput
//                 type="text"
//                 name="city"
//                 placeholder="City"
//                 value={addAddress.city}
//                 onChange={handleRestOfAddress}
//               />
//             </div> */}

//             <div className="w-full h-fit flex justify-between items-center space-x-[5%]">
//               {/* State Dropdown */}
//               <select
//                 name="state"
//                 value={selectedState}
//                 onChange={handleStateChange}
//                 // className="w-[47.5%] h-fit flex flex-col space-y-[2%] font-normal text-[1vw] text-textSecondaryColor"
//                 className="input-primary"
//               >
//                 <option value="">Select State</option>
//                 {Object.keys(stateCityData).map((state) => (
//                   <option key={state} value={state}>
//                     {state}
//                   </option>
//                 ))}
//               </select>

//               {/* City Dropdown */}
//               <select
//                 name="city"
//                 value={selectedCity}
//                 onChange={(e) => setSelectedCity(e.target.value)}
//                 // className="w-[47.5%] h-fit flex flex-col space-y-[2%] font-normal text-[1vw] text-textSecondaryColor"
//                 className="input-primary "
//                 disabled={!selectedState}
//               >
//                 <option value="">Select City</option>
//                 {selectedState &&
//                   stateCityData[selectedState].map((city) => (
//                     <option key={city} value={city}>
//                       {city}
//                     </option>
//                   ))}
//               </select>
//             </div>
//             <CustomSelect
//               dataArray={["Home", "Office", "Other"]}
//               onSelect={handleAddressTypeSelect}
//               selectedItem={addAddress.type}
//             />
//             {addAddress.house?.length > 0 &&
//               addAddress.area?.length > 0 &&
//               addAddress.pincode?.toString().length === 6 &&
//               addAddress.state?.length > 0 &&
//               addAddress.city?.length > 0 &&
//               addAddress.type?.length > 0 ? (
//               <button
//                 className="btn-primary"
//                 style={{ marginTop: "5%" }}
//                 onClick={() => addressSave(addAddress)}
//               >
//                 Save Address
//               </button>
//             ) : (
//               <button
//                 disabled={true}
//                 className="btn-secondary"
//                 style={{ marginTop: "5%" }}
//               >
//                 Save Address
//               </button>
//             )}
//           </div>
//         )}
//       </div>
//     </DashboardWrapper>
//   );
// };

// export default MyAddress;






import React, { lazy, Suspense, useEffect, useState } from "react";
import { useAddressContext } from "../context/AddressContext";
import { MdArrowBackIos, MdKeyboardArrowDown } from "../utils/Icons";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import DashboardWrapper from "../components/DashboardWrapper";
import CustomInput from "../components/CustomComponents/CustomInput";
import CustomSelect from "../components/CustomComponents/CustomSelect";
export const baseUrl = "http://localhost:5000";


const AddressCard = lazy(() => import("../components/AddressCard"));

const MyAddress = () => {
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [stateOpen, setStateOpen] = useState(false);
  const [cityOpen, setCityOpen] = useState(false);

  const {
    addressData,
    addressSave,
    addAddress,
    setAddAddress,
    isAddAddress,
    setIsAddAddress,
    getAddresses,
  } = useAddressContext();
  const navigate = useNavigate();

  const handleStateChange = (e) => {
    const stateValue = e.target.value;
    setSelectedState(stateValue);
    setSelectedCity("");
    setAddAddress((prev) => ({
      ...prev,
      state: stateValue,
      city: "",
    }));
  };

  const handleCityChange = (e) => {
    const cityValue = e.target.value;
    setSelectedCity(cityValue);
    setAddAddress((prev) => ({
      ...prev,
      city: cityValue,
    }));
  };

  // const handleAddAddress = () => {
  //   setIsAddAddress((prev) => !prev);
  // };

  const handleAddAddress = () => {
    // toggle form
    setIsAddAddress((prev) => !prev);

    // reset dropdowns when form is closed or reopened
    setSelectedState("");
    setSelectedCity("");
    setCityList([]);
    setStateOpen(false);
    setCityOpen(false);

    // also clear other form fields if needed
    setAddAddress({
      house: "",
      area: "",
      pincode: "",
      state: "",
      city: "",
      type: ""
    });
  };


  const handleRestOfAddress = (e) => {
    const { name, value } = e.target;
    setAddAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddressTypeSelect = (type) => {
    setAddAddress((prevState) => ({
      ...prevState,
      type,
    }));
  };

  useEffect(() => {

    const token = Cookies.get("token");
    const userId = Cookies.get("userId");

    if (token && userId) {
      getAddresses();
    }
  }, [getAddresses]);

  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const { house, area, pincode, state, city, type } = addAddress;
    const isValid =
      house?.trim() &&
      area?.trim() &&
      pincode?.toString().length === 6 &&
      state?.trim() &&
      city?.trim() &&
      type?.trim();

    setIsFormValid(!!isValid);
  }, [addAddress]);

  const [cityList, setCityList] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);

  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedState) return;

      setLoadingCities(true);
      try {
        const response = await fetch(
          // `http://localhost:5000/api/stateAndCity/getStateAndCity/${selectedState}`
          `${baseUrl}/api/stateAndCity/getStateAndCity/${selectedState}`
        );
        const data = await response.json();
        // console.log("Fetched districts:", data.districts); // check the array
        setCityList(data.districts || []); // <-- use the array
      } catch (error) {
        console.error("Failed to fetch districts:", error);
        setCityList([]);
      }
      setLoadingCities(false);
    };

    fetchCities();
  }, [selectedState]);

  const handleStateSelect = (state) => {
    setSelectedState(state);
    setSelectedCity(""); // reset city
    handleAddressChange("state", state);
    handleAddressChange("city", "");
    setStateOpen(false);
  };

  const handleCitySelect = (city) => {
    setSelectedCity(city);
    handleAddressChange("city", city);
    setCityOpen(false);
  };

  const handleAddressChange = (name, value) => {
    setAddAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchState = {
    'Andhra Pradesh': ["Visakhapatnam", "Vijayawada", "Tirupati"],
    'Arunachal Pradesh': ["Itanagar", "Naharlagun", "Bomdila"],
    Assam: ["Guwahati", "Dibrugarh", "Silchar"],
    Bihar: ["Patna", "Gaya", "Muzaffarpur"],
    Chhattisgarh: ["Raipur", "Bilaspur", "Durg"],
    Goa: ["Panaji", "Margao", "Vasco da Gama"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara"],
    Haryana: ["Gurgaon", "Faridabad", "Panchkula"],
    "Himachal Pradesh": ["Shimla", "Manali", "Dharamshala"],
    Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad"],
    Karnataka: ["Bengaluru", "Mysuru", "Mangaluru"],
    Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode"],
    'Madhya Pradesh': ["Bhopal", "Indore", "Jabalpur"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur"],
    Manipur: ["Imphal", "Thoubal", "Bishnupur"],
    Meghalaya: ["Shillong", "Tura", "Jowai"],
    Mizoram: ["Aizawl", "Lunglei", "Saiha"],
    Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
    Odisha: ["Bhubaneswar", "Cuttack", "Rourkela"],
    Punjab: ["Chandigarh", "Amritsar", "Ludhiana"],
    Rajasthan: ["Jaipur", "Jodhpur", "Udaipur"],
    Sikkim: ["Gangtok", "Namchi", "Pelling"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai"],
    Telangana: ["Hyderabad", "Warangal", "Nizamabad"],
    Tripura: ["Agartala", "Udaipur", "Dharmanagar"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi"],
    Uttarakhand: ["Dehradun", "Haridwar", "Rishikesh"],
    "West Bengal": ["Kolkata", "Howrah", "Siliguri"],
    'Andaman and Nicobar Islands': ["Port Blair", "Diglipur"],
    Chandigarh: ["Chandigarh"],
    'Dadra and Nagar Haveli and Daman and Diu': ["Daman", "Silvassa"],
    Delhi: ["New Delhi", "Dwarka", "Rohini"],
    'Jammu and Kashmir': ["Srinagar", "Jammu", "Anantnag"],
    Ladakh: ["Leh", "Kargil"],
    Lakshadweep: ["Kavaratti", "Agatti"],
    Puducherry: ["Puducherry", "Karaikal"],
  }

  return (
    <DashboardWrapper>
      <div className="w-full h-full">
        <button
          className="flex items-center font-normal text-[4vw] mb-2 lg:hidden lg:text-[1vw] text-textPrimaryColor"
          onClick={() => navigate(-1)}
        >
          {!isAddAddress && (
            <>
              <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
              <span>Back</span>
            </>
          )}
        </button>

        {/* No address case */}
        {addressData?.length === 0 && !isAddAddress && (
          <div className="w-full h-full flex flex-col justify-between items-center">
            <div className="w-full h-[85%] flex justify-center items-center">
              <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                No Address
              </p>
            </div>
            <button className="btn-primary" onClick={handleAddAddress}>
              Add Address
            </button>
          </div>
        )}

        {/* Address list case */}
        {addressData?.length > 0 && !isAddAddress && (
          <div className="w-full h-full flex flex-col justify-between items-center space-y-[3%] lg:space-y-0">
            <div className="w-full h-fit lg:h-[85%] grid grid-cols-1 lg:grid-cols-2 lg:gap-x-[5.5%] gap-y-2 lg:gap-y-[7.5%] overflow-x-hidden overflow-y-scroll scrollbar-hide auto-rows-min">
              <Suspense
                fallback={
                  <div className="w-full h-full flex justify-center items-center">
                    <p className="font-normal text-[1vw] text-textSecondaryColor">
                      Loading addresses...
                    </p>
                  </div>
                }
              >
                {addressData?.map((address, index) => (
                  <AddressCard key={index} data={address} />
                ))}
              </Suspense>
            </div>
            <button className="btn-primary" onClick={handleAddAddress}>
              Add Address
            </button>
          </div>
        )}

        {/* Add address form */}
        {isAddAddress && (
          <div className="w-full h-fit space-y-[3%]">
            <button
              className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
              onClick={handleAddAddress}
            >
              <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
              <span>Back</span>
            </button>
            <div className="w-full h-fit space-y-[1%]">
              <span className="font-medium text-[5vw] lg:text-[1.25vw] text-textPrimaryColor">
                Address Information
              </span>
              <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                Please provide full details of your address for a smooth Home
                collection. Ensure accuracy to avoid delays.
              </p>
            </div>

            {/* House & Area */}
            <div className="w-full h-fit flex justify-between items-center space-x-[5%]">
              <CustomInput
                type="text"
                name="house"
                placeholder="House No."
                value={addAddress.house}
                onChange={handleRestOfAddress}
              />
              <CustomInput
                type="text"
                name="area"
                placeholder="Area"
                value={addAddress.area}
                onChange={handleRestOfAddress}
              />
            </div>

            {/* Pincode input */}
            <div className="w-full h-fit flex justify-between items-center">
              <div className="w-[47.5%] h-fit flex flex-col space-y-[2%]">
                <label
                  htmlFor="pincode"
                  className="font-normal text-[1vw] text-textSecondaryColor"
                ></label>

                <input
                  className="input-primary"
                  type="number"
                  name="pincode"
                  placeholder="Pincode"
                  value={addAddress.pincode}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 6) {
                      handleRestOfAddress(e);
                    }
                  }}
                />
              </div>
            </div>


            {/* ---------------------Final dynamically----------------------------- */}
            {/* State dropdown */}
            {/* <div className="flex gap-8">
              <div className="relative w-full">
                <div
                  className={`dropdown-box flex items-center justify-between rounded-full border border-gray-300 px-4 py-1.5 cursor-pointer bg-white ${stateOpen ? "shadow-md" : ""}`}
                  onClick={() => setStateOpen(!stateOpen)}
                >
                  <span className="text-sm text-gray-700 ">
                    {selectedState || "Select State"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>
                {stateOpen && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
                    {Object.keys(stateCityData).map((state, index) => (
                      <div
                        key={state}
                        className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== Object.keys(stateCityData).length - 1
                          ? "border-b border-gray-200"
                          : ""
                          }`}
                        onClick={() => {
                          setSelectedState(state); 
                          setSelectedCity(""); 
                          setStateOpen(false);
                          if (typeof handleStateChange === "function") {
                            handleStateChange({ target: { name: "state", value: state } });
                          }
                        }}
                      >
                        {state}
                      </div>
                    ))}
                  </div>
                )}
              </div> */}

            {/* -----------State dropdown with State function --------------------------- */}
            {/* <div className="flex gap-8"> */}
            {/* <div className="relative w-full">
                <div
                  className={`dropdown-box flex items-center justify-between rounded-full border border-gray-300 px-4 py-1.5 cursor-pointer bg-white ${stateOpen ? "shadow-md" : ""}`}
                  onClick={() => setStateOpen(!stateOpen)}
                >
                  <span className="text-sm text-gray-700">
                    {selectedState || "Select State"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>

                {stateOpen && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
                  
                    {Object.keys(fetchState).map((state, index, arr) => (
                      <div
                        key={state}
                        className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== arr.length - 1 ? "border-b border-gray-200" : ""
                          }`}
                        onClick={() => {
                          setSelectedState(state); 
                          setSelectedCity(""); 
                          setStateOpen(false);
                        }}
                      >
                        {state}
                      </div>
                    ))}
                  </div>
                )}
              </div> */}



            {/* ------------------dynamical city dropdown---------------- */}
            {/* <div className="relative w-full">
                <div
                  className={`dropdown-box flex items-center justify-between rounded-full border px-4 py-2 ${selectedState
                    ? "bg-white border-gray-300 cursor-pointer"
                    : "bg-gray-100 border-gray-200 cursor-not-allowed"
                    } ${cityOpen ? "shadow-md" : ""}`}
                  onClick={() => selectedState && setCityOpen(!cityOpen)}
                >
                  <span className="text-sm text-gray-700">
                    {selectedCity || "Select City"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>

                {cityOpen && selectedState && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden max-h-60 overflow-y-auto">
                    {cityList.length > 0 ? (
                      cityList.map((city, index) => (
                        <div
                          key={city}
                          className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== cityList.length - 1 ? "border-b border-gray-200" : ""
                            } hover:bg-gray-100`}
                          onClick={() => {
                            setSelectedCity(city);
                            setCityOpen(false);
                          }}
                        >
                          {city}
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-sm text-gray-400">Loading cities...</div>
                    )}
                  </div>
                )}
              </div> */}


            <div className="flex gap-8">
              {/* State Dropdown */}
              <div className="relative w-full">
                <div
                  className={`dropdown-box flex items-center justify-between rounded-full border border-gray-300 px-4 py-1.5 cursor-pointer bg-white ${stateOpen ? "shadow-md" : ""}`}
                  onClick={() => setStateOpen(!stateOpen)}
                >
                  <span className="text-sm md:text-4xl lg:text-sm text-gray-700">
                    {selectedState || "Select State"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>

                {stateOpen && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
                    {Object.keys(fetchState).map((state, index, arr) => (
                      <div
                        key={state}
                        // if state is select 
                        className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== arr.length - 1 ? "border-b border-gray-200" : ""
                          } hover:bg-gray-100`}
                        onClick={() => handleStateSelect(state)} // use handler
                      >
                        {state}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            


              {/* City Dropdown */}
              <div className="relative w-full">
                <div
                  className={`dropdown-box flex items-center justify-between rounded-full border px-4 py-2 ${selectedState
                    ? "bg-white border-gray-300 cursor-pointer"
                    : "bg-gray-100 border-gray-200 cursor-not-allowed"
                    } ${cityOpen ? "shadow-md" : ""}`}
                  onClick={() => selectedState && setCityOpen(!cityOpen)}
                >
                  <span className="text-sm md:text-4xl lg:text-sm text-gray-700">
                    {selectedCity || "Select City"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>

                {cityOpen && selectedState && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden max-h-60 overflow-y-auto">
                    {cityList.length > 0 ? (
                      cityList.map((city, index) => (
                        <div
                          key={city}
                          className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== cityList.length - 1 ? "border-b border-gray-200" : ""
                            } hover:bg-gray-100`}
                          onClick={() => handleCitySelect(city)} // use handler
                        >
                          {city}
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-sm text-gray-400">
                        Loading cities...
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>


            {/* </div> */}


            {/* --------------------------------------------- */}
            {/* Address type selector */}
            <CustomSelect
              dataArray={["Home", "Office", "Other"]}
              onSelect={handleAddressTypeSelect}
              selectedItem={addAddress.type}
            />

            {/* Save button */}
            {addAddress.house?.length > 0 &&
              addAddress.area?.length > 0 &&
              addAddress.pincode?.toString().length === 6 &&
              addAddress.state?.length > 0 &&
              addAddress.city?.length > 0 &&
              addAddress.type?.length > 0 ? (
              <button
                className="btn-primary"
                style={{ marginTop: "5%" }}
                onClick={() => addressSave(addAddress)}
              >
                Save Address
              </button>
            ) : (
              <button
                disabled={true}
                className="btn-secondary"
                style={{ marginTop: "5%" }}
              >
                Save Address
              </button>
            )}
          </div>
        )}
      </div>
    </DashboardWrapper >
  );
};

export default MyAddress;
